module.exports = __webpack_public_path__ + "static/media/icon-next.fca5c454.svg";